<div class="fuse-vertical-navigation-wrapper ">

    <!-- Header -->
    <div class="fuse-vertical-navigation-header">
        <ng-content select="[fuseVerticalNavigationHeader]"></ng-content>
    </div>

    <!-- Content -->
    <div class="fuse-vertical-navigation-content" fuseScrollbar
        [fuseScrollbarOptions]="{ wheelPropagation: inner, suppressScrollX: true }" #navigationContent>
        <!-- Content header -->
        <div class="fuse-vertical-navigation-content-header">
            <ng-content select="[fuseVerticalNavigationContentHeader]"></ng-content>
        </div>

        <ng-container *ngIf="permissionsLoading; else navigationItems">
            <div class="fuse-vertical-navigation-skeleton" aria-hidden="true">
                <div class="fuse-vertical-navigation-skeleton-item" *ngFor="let item of navSkeletonItems">
                    <span class="fuse-vertical-navigation-skeleton-icon"></span>
                    <span class="fuse-vertical-navigation-skeleton-line" [style.width]="item.width"></span>
                    <span *ngIf="item.hasArrow" class="fuse-vertical-navigation-skeleton-arrow"></span>
                </div>
            </div>
        </ng-container>

        <ng-template #navigationItems>
            <!-- Items -->
            <ng-container *ngFor="let item of navToRender; trackBy: trackByFn">
                <!-- Aside -->
                <ng-container *ngIf="item.type === 'aside'">
                    <fuse-vertical-navigation-aside-item class="bg-red-500" [item]="item" [name]="name"
                        [activeItemId]="activeAsideItemId" [autoCollapse]="autoCollapse" [skipChildren]="true"
                        (click)="toggleAside(item)"></fuse-vertical-navigation-aside-item>
                </ng-container>

                <ng-container *ngIf="item.type === 'basic' && isItemVisible(item)">
                    <fuse-vertical-navigation-basic-item [item]="item" [name]="name"
                        (click)="clickOnBasicItem(item)"></fuse-vertical-navigation-basic-item>
                </ng-container>

                <!-- Collapsable (children already filtered) -->
                <ng-container *ngIf="item.type === 'collapsable' && (item.children?.length || 0) > 0">
                    <fuse-vertical-navigation-collapsable-item (click)="collapseClicked(item)" [item]="item" [name]="name"
                        [autoCollapse]="true"></fuse-vertical-navigation-collapsable-item>
                </ng-container>

                <!-- Divider -->
                <ng-container *ngIf="item.type === 'divider'">
                    <fuse-vertical-navigation-divider-item [item]="item"
                        [name]="name"></fuse-vertical-navigation-divider-item>
                </ng-container>

                <!-- Group -->
                <ng-container *ngIf="item.type === 'group'">
                    <fuse-vertical-navigation-group-item [item]="item" [name]="name"
                        [autoCollapse]="autoCollapse"></fuse-vertical-navigation-group-item>
                </ng-container>

                <!-- Spacer -->
                <ng-container *ngIf="item.type === 'spacer'">
                    <fuse-vertical-navigation-spacer-item [item]="item"
                        [name]="name"></fuse-vertical-navigation-spacer-item>
                </ng-container>

            </ng-container>
        </ng-template>

        <!-- Content footer -->
        <div class="fuse-vertical-navigation-content-footer">
            <ng-content select="[fuseVerticalNavigationContentFooter]"></ng-content>
        </div>
    </div>

    <!-- Footer -->
    <div class="fuse-vertical-navigation-footer">
        <ng-content select="[fuseVerticalNavigationFooter]"></ng-content>
    </div>
</div>

<!-- Aside -->
<ng-container *ngIf="activeAsideItemId">
    <div class="fuse-vertical-navigation-aside-wrapper" fuseScrollbar
        [fuseScrollbarOptions]="{ wheelPropagation: false, suppressScrollX: true }" [@fadeInLeft]="position === 'left'"
        [@fadeInRight]="position === 'right'" [@fadeOutLeft]="position === 'left'"
        [@fadeOutRight]="position === 'right'">
        <!-- Items -->
        <ng-container *ngFor="let item of navToRender; trackBy: trackByFn">
            <!-- Aside -->
            <ng-container *ngIf="item.type === 'aside' && item.id === activeAsideItemId">
                <fuse-vertical-navigation-aside-item [item]="item" [name]="name"
                    [autoCollapse]="autoCollapse"></fuse-vertical-navigation-aside-item>
            </ng-container>
        </ng-container>
    </div>
</ng-container>